import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './node.types';
import { IChart } from '../chart/chart.types';

const baseSelectors = generateResourceSelectors<types.IOrganizationChartNode>((state) => state.resource.node);

export const nodeSelectors = {
  ...baseSelectors,
  selectNodesByChartId: (
    state: Parameters<typeof baseSelectors.selectResourceList>[0],
    chartId: IChart['id'],
  ): types.IOrganizationChartNode[] =>
    baseSelectors.selectResourceList(state).filter((node) => String(node.chartId) === String(chartId)),
};
